import React from "react";
import { format } from "date-fns";
import { DATE_FNS_SHORT_DATE_FORMAT } from "../../../shared/constants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";

import { WithIcon, WithTooltip } from "../../../shared/table-helpers";

export const columns = [
    {
        Header: "Upc",
        accessor: "upc",
        Cell: (row) => {
            const fullUpc = row.original.productModifier ? `${row.value}-${row.original.productModifier}` : row.value;

            return fullUpc;
        },
    },
    {
        Header: "Package Level",
        accessor: "packageLevelName",
    },
    {
        Header: WithTooltip("Finalized"),
        accessor: "isFinalized",
        Cell: (row) => {
            return row.value ? "Completed" : "In Progress";
        },
    },
    {
        Header: WithTooltip("Updated"),
        accessor: "updatedOn",
        Cell: (row) => {
            const dateString = row.value ? format(new Date(row.value), DATE_FNS_SHORT_DATE_FORMAT) : "";

            return WithTooltip(dateString);
        },
    },
];

export const matchColumns = (removeLink) => {
    return [
        {
            Header: "Upc",
            accessor: "upc",
            Cell: (row) => {
                const fullUpc = row.original.productModifier ? `${row.value}-${row.original.productModifier}` : row.value;

                return fullUpc;
            },
        },
        {
            Header: "Package Level",
            accessor: "packageLevelName",
        },
        {
            Header: WithIcon("Delete", faTrash),
            accessor: "key",
            Cell: (row) => {
                return (
                    <button
                        className="button -text"
                        onClick={() => {
                            removeLink(row.value);
                        }}
                    >
                        <FontAwesomeIcon icon={faTrash} />
                    </button>
                );
            },
            width: 40,
            style: { textAlign: "center" },
        },
    ];
};
